// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  createdAt: __t.timestamp(),
  started: __t.bool(),
  secondsUntilStart: __t.u16(),
  gameMode: __t.string(),
  teamMode: __t.string(),
  captureLimit: __t.u16(),
  team0Score: __t.u16(),
  team1Score: __t.u16(),
  mobaWaveNumber: __t.u16(),
  gameOver: __t.bool(),
  winnerId: __t.string(),
  winnerTeamId: __t.i32(),
});
